import { collection, addDoc, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

const COLLECTION_NAME = 'plData';

export const savePLData = async (plData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...plData,
      createdAt: new Date().toISOString()
    });
    return { id: docRef.id, ...plData };
  } catch (error) {
    console.error('Error saving P&L data:', error);
    throw new Error('Failed to save P&L data: ' + error.message);
  }
};

export const getPLData = async (userId) => {
  try {
    const plDataRef = collection(db, COLLECTION_NAME);
    const q = query(
      plDataRef, 
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching P&L data:', error);
    throw new Error('Failed to fetch P&L data: ' + error.message);
  }
};